import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import MainPage from "@/views/MainPage/MainPage"

interface Ilist{
    title:string,
    holder:string,
    type:string,
    data:string,
    ora:string,
    confidentiality:string,
    password:string,
    description:string
}


@Component({components:{MainPage}})
export default class BineAiVenit extends Vue {
    myBoolTrue:boolean=true;
    myBoolFalse:boolean=false;
    loadingApp:boolean=false;
    xsm:string='xsm';
    sizes:Array<string>= ['xs', 'sm', 'md', 'lg', 'xl'];
    dialogEditNoteVisible:boolean=false;
    ajaxIsRunning:boolean=false;
    idNote:number=0;
    visibleInputTag:boolean=false;
    input_text_new_tag:string='';
    input_filter_note:string='';
    allTags:Array<{key:string,label:string}>=[];
    tagsForFilterNotes:Array<string>=[];
    tags_availlable:Array<{key:string,label:string}>=[];
    optionsTypeOfCelebration:Array<string>= [
        'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
    ];
    new_list:Ilist={
        title:'',
        holder:'',
        type:'',
        data:'',
        ora:'',
        confidentiality:'',
        password:'',
        description:''
    }

    dynamicTags:Array<string>= ['Tag 1', 'Tag 2', 'Tag 3'];
    inputVisible:boolean= false;
    inputValue:string= '';
    $refs:any;
    private userStore=getModule(User);



    constructor(){
        super();
    }




}
